<div class="container-fluid justify-content-center profile-section mt-3 mb-3 p-2">
  <div class="row">
    <!-- Profile Info Left Hand side starts -->
    <div class="col-md-4">
      <div class="py-2 px-3 d-flex flex-column">
        <img *ngIf="midwife.profileImage" [src]="midwife.profileImage" alt="" class="profile-img">
        <img *ngIf="!midwife.profileImage" src="../../../../assets/Images/pro-pic.png" alt="" class="profile-img">
        <span class="profile-name mt-2">{{midwife?.name}}</span>
        <div class="row justify-content-center mt-3">
          <button class="profile-chip mr-2"><i class="fas fa-star mr-1 star"></i>{{midwife?.rating}} <span
              class="text-muted">({{midwife?.numReviews}})</span></button>
          <button class="profile-chip mr-2">{{midwife?.experienceInYears}} years</button>
        </div>
        <div>
          <div class="divider"></div>
          <div class="d-flex flex-row text-profile-info"> <i class="fas fa-phone profile-icons"></i>
            {{midwife.user[0]?.userPhonenumber}}
            (Work) </div>
          <div class="d-flex flex-row text-profile-info"><i
              class="fas fa-envelope profile-icons"></i>{{midwife.user[0]?.userEmail}}</div>
          <div class="d-flex flex-row text-profile-info"><i
              class="fas fa-map-marker-alt ml-1 profile-icons"></i>{{midwife?.address}}</div>
          <div style="display: flex; justify-content: center;">
            <button class="btn btn-theme-inverse m-3" (click)="createRoom()">
              LIVE CHAT
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Profile Info Left Hand side Ends -->

    <!-- Profile Info Right Hand side starts -->
    <div class="col-md-8 profile-detail">
      <div class="d-flex flex-column mt-3 ">
        <div class="profile-top-section">
          <div class="d-flex flex-column">
            <div class="profile-label">Specialized in</div>
            <div class="profile-value">{{midwife?.speciality}}</div>
          </div>
          <div class="d-flex flex-column my-3 my-xl-0 mx-xl-4">
            <div class="profile-label">Languages</div>
            <div class="profile-value">{{midwife?.languages}}</div>
          </div>
          <div class="d-flex flex-column">
            <div class="profile-label">Ethnicity</div>
            <div class="profile-value">{{midwife?.ethnicity}}</div>
          </div>
        </div>
        <div class="divider"></div>
        <div>
          <div class="d-flex flex-column pt-1 pb-2">
            <div class="profile-label-lg">About me</div>
            <div class="profile-content">{{midwife?.intro}}</div>
          </div>
          <div class="d-flex flex-column py-2">
            <div class="profile-label-lg">Areas Where I Save</div>
            <div class="d-flex flex-row flex-wrap mt-2">
              <button class="mr-2 profile-areas" *ngFor="let service of midwife.serviceAreas">{{service}}</button>
            </div>
          </div>
        </div>
        <div>

        </div>
      </div>
    </div>
    <!-- Profile Info Left Hand side Ends -->
  </div>
</div>